<template>
  <div class="content">
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="newCategoryDialog"
      max-width="900"
    >
      <NewCategory
        :category="currentCategory"
        @action="newCategoryDialog = true"
        @close="(newCategoryDialog = false), updateTable()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Dialog DELETE  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="deleteDialog"
      max-width="550px"
    >
      <DeleteModal
        :quantidade="this.quantCategoryProduct"
        title="Deletar"
        textMessage="Tem certeza que deseja deletar esta categoria?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation="produto(s) armazena(m) essa categoria. Ao excluí-la você também as retira do cadastro desse(s) produto(s) "
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="performAction()"
      />
    </v-dialog>

    <v-dialog
        v-model="confirmActionRecordCannotDeleteModalDialog"
        max-width="700"
    >
      <RecordCannotDeleteModal
          :recordsCannotDelete="recordsCannotDelete"
          :title="titleRecordsCannotDelete"
          @close="(confirmActionRecordCannotDeleteModalDialog = false)"
      />
    </v-dialog>

    <v-card class="filter-card mt-0 mb-6" elevation="0">
      <v-row class="pa-0 ma-0 mn-4">
        <v-col cols="12">
          <span class="filter-text">
            Cadastre as categorias que serão visiveis para cadastro de produtos. Edite e
            delete categorias existentes.
          </span>
        </v-col>

        <v-col
          class="d-flex flex-column align-start my-1 py-1"
          cols="12"
          sm="6"
          md="6"
          lg="6"
        >
          <v-text-field
            outlined
            class="px-0"
            style="
              border: 1px solid #979797;
              border-radius: 7.5px;
              width: 100%;
              margin-bottom: 16px;
            "
            hide-details
            color="black"
            background-color="#F5F5F5"
            placeholder="Seletor ou nome"
            v-model="filter.categoryName"
            attach
            v-on:keyup="filterTable"
            :loading="loading"
          >
            <template v-slot:append>
              <v-icon class="pt-0" color="normalred" size="26">mdi-magnify</v-icon>
            </template>
          </v-text-field>
        </v-col>

        <v-col
          class="d-flex flex-row justify-center my-1 py-1"
          cols="12"
          sm="2"
          md="2"
          lg="2"
        >
          <v-btn
            height="56"
            outlined
            elevation="0"
            class="reset-button"
            style="border: 1px solid; border-radius: 7.5px"
            @click="reset"
            :loading="loading"
          >
            <span> Limpar Filtros</span>
          </v-btn>
        </v-col>

        <v-col
          class="d-flex flex-row justify-center my-1 py-1"
          cols="12"
          sm="2"
          md="2"
          lg="2"
        >
          <v-btn
            block
            class="mr-2 add-button"
            style="border-radius: 7.5px"
            height="56"
            elevation="0"
            color="normalred"
            @click="
              dialogKey = !dialogKey;
              currentCategory = {};
              newCategoryDialog = true;
            "
            :loading="loading"
          >
            <span>Nova categoria</span>
          </v-btn>
        </v-col>

        <v-col
          class="d-flex flex-row justify-center my-1 py-1"
          cols="12"
          sm="2"
          md="2"
          lg="2"
        >
          <v-btn
            block
            class="mr-2 add-button"
            height="56"
            elevation="0"
            color="normalred"
            @click="toSortCategory()"
            style="border-radius: 7.5px"
            :loading="loading"
          >
            <span>Ordenar Categoria</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-data-table
      id="category-table"
      class="elevation-0"
      loading-text="Carregando..."
      no-data-text="Nenhuma categoria encontrada"
      hide-default-footer
      :loading="loading"
      :headers="headers"
      :items="categories"
      :items-per-page="pageSize"
      :header-props="headerProps"
      v-model="selectedCategories"
      show-select
      item-key="categoryId"
      :single-select="false"
    >
      <template v-slot:[`header.actions`]="{ header }">
        <span style="padding-right: 20px"> {{ header.text }}</span>
      </template>

      <template v-slot:[`item.categoryName`]="{ item }">
        {{ item.categoryName }}
      </template>

      <template v-slot:[`item.categoryInventory`]="{ item }">
        {{ item.categoryInventory }}
      </template>

      <template v-slot:[`item.statusOnMenu`]="{ item }">
        {{ item.statusOnMenu == 1 ? "Visível" : "Oculto" }}
      </template>

      <template v-slot:[`item.showHomepage`]="{ item }">
        {{ item.showHomepage ? "Sim" : "Não" }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 4px"
              width="35"
              height="35"
              small
              class="edit-button"
              color="quaternary"
              @click="toSortSubCategory(item.categoryId)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-queue-first-in-last-out</v-icon>
            </v-btn>
          </template>
          <span>Ordenar subcategorias</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 4px"
              width="35"
              height="35"
              small
              class="edit-button ml-4"
              color="quaternary"
              @click="editCategory(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              fab
              tile
              style="border-radius: 4px"
              width="35"
              height="35"
              small
              class="remove-button ml-4 my-2"
              color="red"
              @click="deleteCategory(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Remover</span>
        </v-tooltip>
      </template>

      <template v-slot:header.data-table-select="{ on, props}">
        <v-simple-checkbox
            color="#bc0000"
            v-bind="props"
            v-on="on"
            :ripple="false"
        >
        </v-simple-checkbox>
      </template>

      <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
        <v-simple-checkbox
            :ripple="false"
            @click="addCategoryListSelectedCategories(item)"
            :value="isSelected"
            color="#bc0000"
            v-bind="props"
            v-on="on"
        >
        </v-simple-checkbox>
      </template>

      <template v-slot:footer >
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>

        <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedCategories.length > 0">
          <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
            <label>Selecione a ação</label>
            <v-select
                class="ma-0 pa-0 "
                dense
                v-model="actionSelected"
                outlined
                style="border-radius: 3px!important"
                :items="actions"
                item-text="label"
                item-value="value"
                placeholder="Selecione a ação"
            >
            </v-select>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
            <v-btn
                class="secondary-button mt-5 ml-3"
                style="height: 40px!important; border-radius: 7.5px!important"
                height="40"
                width="100%"
                elevation="0"
                :disabled="!actionSelected"
                @click="confirmActionDialog = true"
            >
              {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<style scoped>
.content {
  background: #e5e5e5;
}

.filter-card {
  background: #ffffff;
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1);
  border-radius: 6px;
}

.filter-text {
  font-weight: 300;
  font-size: 20px;
  line-height: 35px;
  color: #9c9c9c;
}

.add-button {
  background: #bc0000;
  border-radius: 10px;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
  transition: 0.3s;
}

.add-button:hover {
  background: #e8161e !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.reset-button {
  border-radius: 10px;
  transition: 0.3s;
}

.reset-button:hover {
  color: #fff;
  background: #000000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
}

.edit-button {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: bold;
  transition: 300ms;
}

.edit-button:hover {
  background: #2d3038;
  color: white !important;
}

.edit-button:focus {
  background: #444854;
  color: white !important;
}

.remove-button {
  border: 2px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}
</style>

<script>
import ApiService from "../../../../../services/ApiService";
import Vue from "vue";
import DeleteModal from "../../../components/DeleteModal.vue";
import NewCategory from "../components/newCategory.vue";
import RecordCannotDeleteModal from "@/views/pages/components/RecordCannotDeleteModal.vue";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  props: {
    title: String,
    category: Object,
    filtro: Object,
  },

  components: {
    Pagination,
    ConfirmModal,
    RecordCannotDeleteModal,
    NewCategory,
    DeleteModal,
  },

  data: () => ({
    recordsCannotDelete: [],
    titleRecordsCannotDelete: "",
    selectedCategories: [],
    actions: [
      { label: "Excluir categoria(s)", value: 1},
      { label: "Ocultar categoria(s) no menu principal do B2C", value: 2},
      { label: "Mostrar categoria(s) no menu principal do B2C", value: 3},
      { label: "Não mostrar categoria(s) na página principal do B2C", value: 4},
      { label: "Mostrar categoria(s) na página principal do B2C", value: 5},
    ],
    actionSelected: null,
    confirmActionRecordCannotDeleteModalDialog: false,
    confirmActionDialog: false,
    quantCategoryProduct: 0,
    newCategoryDialog: false,
    deleteDialog: false,
    closeNoLoading: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    currentCategory: {},
    categories: [],
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 15,
    filter: {
      page: 1,
      pageSize: 15,
    },
    btnColor: "",
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    error: false,
    show: false,
    message: "",
    headers: [
      {
        text: "Nome",
        align: "start",
        class: "item",
        value: "categoryName",
      },
      {
        text: "Produtos em uso",
        class: "item",
        value: "categoryInventory",
        align: "center",
      },
      {
        text: "Menu Principal B2C",
        class: "item",
        value: "statusOnMenu",
        align: "center",
      },
      {
        text: "Mostrar na home",
        class: "item",
        value: "showHomepage",
        align: "center",
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "end",
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
  }),

  computed: {},

  async created() {
    await this.updatePageView();
  },

  methods: {
    performAction(){
      this.confirmActionDialog = false;
      switch (this.actions.find((x) => x.value === this.actionSelected).label) {
        case 'Ocultar categoria(s) no menu principal do B2C':
        case 'Mostrar categoria(s) no menu principal do B2C':
          this.updateStatusOnMenuCategories()
          break
        case 'Não mostrar categoria(s) na página principal do B2C':
        case 'Mostrar categoria(s) na página principal do B2C':
          this.updateShowHomepageCategories()
          break
        case 'Excluir categoria(s)':
          this.removeCategories()
          break
        default:
      }
    },
    updateStatusOnMenuCategories(){
      try {
        const selectedCategories = JSON.parse(JSON.stringify(this.selectedCategories))
        selectedCategories.forEach((x) => {
          x.statusOnMenu = this.actionSelected === 2 ? 0 : 1;
        })

        this.apiService
            .put("category/status_menu/list", selectedCategories)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Categorias atualizadas com sucesso.",
                trace: null,
              });
              this.confirmActionDialog = false
              this.updateTable();
            })
            .catch(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível excluir os cupons.",
                message: "",
                trace: null,
              });
            });
      } catch (e) {
      }
    },

    updateShowHomepageCategories(){
      try {
        const selectedCategories = JSON.parse(JSON.stringify(this.selectedCategories))
        selectedCategories.forEach((x) => {
          x.showHomepage = this.actionSelected === 5;
        })

        this.apiService
            .put("category/show_home/list", selectedCategories)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Categorias atualizadas com sucesso.",
                trace: null,
              });
              this.confirmActionDialog = false
              this.updateTable();
            })
            .catch(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível excluir os cupons.",
                message: "",
                trace: null,
              });
            });
      } catch (e) {
      }
    },

    removeCategories(){
      try {
        this.recordsCannotDelete = [];
        this.selectedCategories.forEach((category) => {
          const itens = []
          if (category.products && category.products.length > 0) {
            itens.push('Subcategoria está relacionada a produto')
          }

          if (category.subCategoriesToCategory && category.subCategoriesToCategory.length > 0) {
            itens.push('Subcategoria está relacionada a subcategoria')
          }

          if (itens.length > 0){
            this.recordsCannotDelete.push(
                {
                  subTitle: `Categoria: <strong>${category.categoryName}</strong>`,
                  motives: itens,
                }
            )
          }
        })

        if (this.recordsCannotDelete.length > 0) {
          this.confirmActionRecordCannotDeleteModalDialog = true
          this.confirmActionDialog = false
          this.titleRecordsCannotDelete = `Categorias que não podem serem excluídos`
          return
        }

        this.apiService
            .post("subCategory/delete/list", this.selectedSubcategories)
            .then(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: "Subcategorias excluídas com sucesso.",
                trace: null,
              });
              this.confirmActionDialog = false
              this.updateTable();
            })
            .catch(() => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Não foi possível excluir os cupons.",
                message: "",
                trace: null,
              });
            });
      } catch (e) {

      }
    },

    addCategoryListSelectedCategories(category){
      const categoryFind = this.selectedCategories.findIndex((x) => x.categoryId === category.categoryId)
      if (categoryFind > -1) {
        this.selectedCategories.splice(categoryFind, 1)
      } else {
        this.selectedCategories.push(category)
      }
    },

    async updatePageView() {
      // this.filter.CategoryName = null;
      await this.updateTable();
    },

    async toSortCategory() {
      await this.$router.push(
          {
            path: 'ordem-visualizacao-categoria',
          }
      )
    },

    async toSortSubCategory(categoryId) {
      await this.$router.push(
          {
            path: `ordem-visualizacao-subcategoria`,
            query: {categoryId}
          }
      )
    },

    editCategory(item) {
      this.currentCategory = item;
      this.dialogKey = !this.dialogKey;
      this.newCategoryDialog = true;
      // this.$emit("editCategory", item);
    },

    async deleteCategory(item) {
      this.currentCategory = item;

      await this.apiService
        .get(`productcategory/listByCategory/${this.currentCategory.categoryId}`)
        .then((response) => {
          this.quantCategoryProduct = response.length;
        })
        .catch(() => {});

      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    async remove(item) {
      this.loading = true;
      await this.apiService
        .delete(`category/delete`, this.currentCategory)
        .then(() => {
          this.updateTable();
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch(() => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    action() {
      this.$emit("action");
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;
      await this.apiService
        .post(`category/list`, this.filter)
        .then((response) => {
          this.categories = response.categories;
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
          this.loading = false;
          this.isLoading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    async backPage() {
      this.filter.page -= 1;
      this.page = this.filter.page;
      await this.updateTable();
    },

    async nextPage() {
      this.filter.page += 1;
      this.page = this.filter.page;
      await this.updateTable();
    },


    close() {
      this.$emit("close");
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 15,
      };
      this.page = 1;
      this.updateTable();
    },

    filterTable() {
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      this.updateTable();
    },
  },

  watch: {
  },
};
</script>
s
